module.exports = __webpack_public_path__ + "img/icon-tiger-dagon2.0a59e565.png";